import moment from 'moment'

const events = {
    namespaced: true,
    state: {
        events:null,
        eventTimes: null,
        eventsViewTime: null,
        messagesViewTime: null
    },
    mutations: {
        setEvents( state , newEvents ) {
            state.events = newEvents
        },
        setEventTimes( state , newEventTimes ) {
            state.eventTimes = newEventTimes
        },
        setEventsViewTime( state ) {
            state.eventsViewTime = moment()
        },
        setMessagesViewTime( state ) {
            state.messagesViewTime = moment()
        }
    },
    actions: {
        updateEvents(context) {
            const now = moment()
            this._vm.$traveller_http.get('/traveller/restui/event/eventList', { params: { "startTime": now.format()}})
                .then(response => {
                    if( response.status == 200 ) {
                        let newEvents = response.data.data
                        context.commit('setEvents' , newEvents.sort( eventTimeCompare ) )
                    }
                }).catch( error => {
                    console.log( "Error getting eventList")
                    console.log( error )
                })
        },
        updateEventTimes(context) {
            this._vm.$traveller_http.get('/traveller/restui/event/eventTimes')
                .then( response => {
                    if( response.status == 200 && response.data.code == 0 ) {
                        const eventTimes = response.data.data
                        context.commit('setEventTimes' , eventTimes )
                    }
                })
        }

    }
}

function eventTimeCompare( a , b ) {
    const timeA = moment( a.eventTime )
    const timeB = moment( b.eventTime )
    return timeA.isBefore( timeB )
}

export default events;